import React from "react"
import PropTypes from "prop-types"
import * as styles from "./BrandTile-tw-styles"
import Link from "../../UI/Link/Link"
import Image from "../../UI/Image/Image"
import useImage from "../../../hooks/useImage"
import ProfileSvg from "../../../assests/icons/ProfileSvg"
import HoverProfileSvg from "../../../assests/icons/HoverProfileSvg"

const BrandTile = props => {
  const { item } = props
  const { category = {}, image = {}, title = "", link = {} } = item
  const style = styles.defaultStyle
  const { altText, foregroundImg } = useImage(image)

  return (
    <div className={style?.profileWrapper} key={item?.name}>
      <div data-types={category?.id} className={style?.profileCardWrapper}>
        <Link {...item?.link} className={style?.profileCardWrapperLink}>
          <div className={style?.profileShapePic}>
            <ProfileSvg color={item?.svgColor} />
            <HoverProfileSvg color={item?.svgColor} />
            <Image
              className={style?.profileImg}
              contentfulImage={foregroundImg}
              alt={altText}
            />
          </div>
          <div className={style?.profileName}>{item?.title}</div>
          <div className={style?.profileDesignation}>{item?.text}</div>
        </Link>
      </div>
    </div>
  )
}

BrandTile.propTypes = {
  item: PropTypes.object,
}

export default BrandTile
